import { createAction } from '@reduxjs/toolkit';

import { IAddItems, IAlbumId, ICreateAlbumRequest, ICreateAlbumSuccess, ILoadAlbumsListSuccess, ILoadAlbumSuccess } from './albums.types';

export const createAndPublishAlbumRequest = createAction<ICreateAlbumRequest>('albums/createAndPublishAlbumRequest');
export const createAlbumSuccess = createAction<ICreateAlbumSuccess>('albums/createAlbumSuccess');

export const loadAlbumsListRequest = createAction('albums/loadAlbumsListRequest');
export const loadAlbumsListSuccess = createAction<ILoadAlbumsListSuccess>('albums/loadAlbumsListSuccess');

export const loadAlbumRequest = createAction<IAlbumId>('albums/loadAlbumRequest');
export const loadAlbumSuccess = createAction<ILoadAlbumSuccess>('albums/loadAlbumSuccess');
export const loadAlbumFail = createAction<IAlbumId>('albums/loadAlbumFail');

export const albumsLoadMoreRequest = createAction('albums/albumsLoadMoreRequest');

export const createAlbumRequest = createAction<string | undefined>('albums/createAlbumRequest');

export const addItemsFromCloudToAlbumRequest = createAction<{ id: string } | undefined>('albums/addItemsFromCloudToAlbumRequest');

export const addFilesToAlbumSuccess = createAction<IAddItems>('albums/addFilesToAlbumSuccess');
